import { PipelineBase } from './base/pipeline-base';

export class Pipeline extends PipelineBase { }